import {
  ModelConceptHierarchy,
  RelationshipMapping,
} from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  isModelConceptHierarchyLabel,
  isRelationshipMapping,
} from 'src/containers/ProjectDiagram/utils/data';
import {
  getAllDomainsAndRanges,
  isValidMappingDomainAndRange,
} from 'src/containers/ProjectDiagram/utils/isValidDomainAndRange';
import { removeRelationshipMapping } from 'src/containers/ProjectDiagram/utils/mapping/removeRelationshipMapping';
import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { getLabelKeyFromHierarchyKey } from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/createModelConceptHierarchyLabel';

// Note: use of this function should always be followed up with
// cleanupModelConceptHierarchyMappings in the same commit
// to the diagram model
export const removeModelConceptHierarchy =
  (data: ModelConceptHierarchy) => (model: Model) => {
    model.removeLinkData(data);

    const labelKey = getLabelKeyFromHierarchyKey(data.key);
    const labelData = model.nodeDataArray.find(
      (nodeData) =>
        isModelConceptHierarchyLabel(nodeData) && nodeData.key === labelKey
    );

    if (labelData) {
      model.removeNodeData(labelData);
    }

    const { classMappingIriByKey, domainsAndRanges } =
      getAllDomainsAndRanges(model);

    const hierarchyIris = new Set<string | undefined>([
      getModelConceptClassValue(data.to),
      getModelConceptClassValue(data.from),
    ]);

    const linkDataToRemove: RelationshipMapping[] = [];
    model.linkDataArray.forEach((linkData) => {
      if (!isRelationshipMapping(linkData)) {
        return;
      }

      if (
        isValidMappingDomainAndRange(
          linkData,
          classMappingIriByKey,
          domainsAndRanges
        )
      ) {
        return;
      }

      if (
        hierarchyIris.has(
          linkData.from
            ? classMappingIriByKey.get(linkData.from)
            : linkData.fromClassIri
        ) ||
        hierarchyIris.has(
          linkData.to
            ? classMappingIriByKey.get(linkData.to)
            : linkData.toClassIri
        )
      ) {
        // remove relevant relationship mappings
        linkDataToRemove.push(linkData);
      } else {
        // do not remove irrelevant relationship mappings
        console.warn(`Invalid relationship mapping (id: ${linkData.value})`);
      }
    });
    // do not mutate linkDataArray while iterating through linkDataArray
    linkDataToRemove.forEach((linkData) =>
      removeRelationshipMapping(linkData)(model)
    );
  };
